'use client';

import Script from 'next/script';

/**
 * CrossDomainScript is a client-side component for inserting OneTrust script.
 * It generates the JWT for OneTrust on the client and then inserts the finished script object.
 * Note that the script content will be dynamically updated after token generation.
 */
export function CrossDomainScript({
    token,
    customerKey,
}: Readonly<{
    token: string;
    customerKey: string;
}>) {
    return (
        <Script
            id="OneTrust-Cross-Domain"
            data-testid="onetrust-cross-domain"
            dangerouslySetInnerHTML={{
                __html: `var OneTrust = { dataSubjectParams: { id: ${customerKey}, isAnonymous: false, token: ${token} } };`,
            }}
        />
    );
}
